/**
 * @flow
 * @relayHash f13bfc80ca77d9fa94b0d1089521eca3
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type DeleteWidgetMutationVariables = {|
  input: {
    id: string;
    clientMutationId?: ?string;
  };
|};

export type DeleteWidgetMutationResponse = {|
  +deleteWidget: ?{|
    +id: ?string;
    +reportId: ?string;
  |};
|};
*/


/*
mutation DeleteWidgetMutation(
  $input: DeleteWidgetInput!
) {
  deleteWidget(input: $input) {
    id
    reportId
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "DeleteWidgetInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteWidgetMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "DeleteWidgetInput!"
          }
        ],
        "concreteType": "DeleteWidgetPayload",
        "name": "deleteWidget",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "reportId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "DeleteWidgetMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "DeleteWidgetInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "DeleteWidgetMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "DeleteWidgetInput!"
          }
        ],
        "concreteType": "DeleteWidgetPayload",
        "name": "deleteWidget",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "reportId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation DeleteWidgetMutation(\n  $input: DeleteWidgetInput!\n) {\n  deleteWidget(input: $input) {\n    id\n    reportId\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/mutations/__generated__/DeleteWidgetMutation.graphql.js